import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import { useStore } from '@feathr/extender/state';

import { skeleton } from '@feathr/components/dist/style/skeleton.css';

interface IProps {
  className?: string;
  id: string;
}

function TemplateLabel({ className, id }: Readonly<IProps>): JSX.Element {
  const { Templates } = useStore();
  const template = Templates.get(id);

  return (
    <div className={classNames({ [skeleton]: template.isPending }, className)}>
      {template.get('name', 'placeholder') as string}
    </div>
  );
}

export default observer(TemplateLabel);
